<template>
  <el-card class="my-card" ref="myCard">
    <div style="font-size: 25px; text-align: left">
      个人信息<br />
      <p />
    </div>
    <div
      style="
        border: 0px solid red;
        width: 200px;
        height: 870px;
        font-size: 16px;
        text-align: left;
        margin: 0px 50px;
        float: left;
      "
    >
      账号：
      <p />
      {{ mainData.userAccount }}<br />
      <hr />
      用户名称：
      <p />
      {{ mainData.userName }}<br />
      <hr />
      用户邮箱：
      <p />
      {{ mainData.userEmail }}<br />
      <hr />
      联系号码：
      <p />
      {{ mainData.userPhone }}<br />
      <hr />
      用户工号：
      <p />
      {{ mainData.empNumber }}<br />
      <hr />
    </div>
    <div style="font-size: 25px; margin: -55px 0px 0px -300px">修改密码</div>
    <div
      style="
        border: 0px solid red;
        width: 300px;
        float: left;
        margin: 10px 200px;
      "
    >
      <el-form
        :model="possform"
        class="demo-form-inline"
        :rules="rules"
        style="width: 250px"
        ref="possform"
      >
        <el-form-item label="原密码" prop="oldpossword">
          <el-input
            v-model="possform.oldpossword"
            show-password
            placeholder="原密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newpossword">
          <el-input
            v-model="possform.newpossword"
            show-password
            placeholder="新密码"
            @input="passExist()"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="newposswordtwo">
          <el-input
            v-model="possform.newposswordtwo"
            show-password
            placeholder="确认新密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">修改</el-button>
          <el-button type="info" @click="qingchu">清除</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>



<script>
export default {
  name: "center",
  data() {
    let validPassword = (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,20}$/;
      if (!reg.test(value)) {
        callback(new Error("密码必须是由4-20位字母+数字组合"));
      } else {
        callback();
      }
    };
    var validateOld = (rule, value, callback) => {
      if (this.$md5(value) != this.userPasswd) {
        // console.log(value);
        // console.log(this.$md5(value));
        // console.log(this.userPasswd);
        callback(new Error("密码错误，请重新输入！"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (this.mainData.userAccount != "admin") {
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/;
        if (value === "") {
          callback(new Error("请输入新密码"));
        } else if (this.$md5(value) == this.userPasswd) {
          callback(new Error("新密码不能和当前密码一致"));
        } else {
          callback();
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.possform.newpossword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        oldpossword: [
          {
            required: true,
            validator: validateOld,
            trigger: "blur",
          },
        ],
        newpossword: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
        newposswordtwo: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur",
          },
        ],
      },
      userid: 0,
      userPasswd: "",
      passIsExist: true, //密码不能和最近三次一样
      possform: {
        oldpossword: "",
        newpossword: "",
        newposswordtwo: "",
      },
      mainData: {
        createTime: "",
        deleteFlag: null,
        empNumber: "",
        userAccount: "",
        userEmail: "",
        userId: null,
        userName: "",
        userPasswd: "",
        userPhone: "",
      },
    };
  },
  props: {},
  mounted() {},
  created: function () {
    this.userid = localStorage.getItem("id");
    this.userAccount = localStorage.getItem("user");
    this.userPasswd = localStorage.getItem("password");
    this.useridAll();
  },
  methods: {
    //表单验证
    submitForm(formName) {
      let r = Boolean;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          r = true;
        } else {
          r = false;
        }
      });
      return r;
    },
    /**
     * 修改密码
     **/
    onSubmit() {
      if (this.submitForm("possform")) {
        if (this.possform.newpossword == this.possform.newposswordtwo) {
          this.$http
            .request({
              url: "api/user/user_repassword",
              method: "PUT",
              showLoading: true,
              params: {
                oldPassword: this.possform.oldpossword,
                newPassword: this.possform.newpossword,
                operaAccount: this.userAccount,
                userId: this.userid,
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$notify({
                  title: "成功",
                  message: "修改成功！",
                  type: "success",
                });
                this.systemLog();
                this.$store.commit("clearTags");
                this.jump("/login");
              } else {
                this.$notify.error({
                  title: "失败",
                  message: resp.message,
                });
              }
              this.qingchu();
            })
            .catch((error) => {});
        } else {
          this.$notify.error({
            title: "失败",
            message: "新密码不一致",
          });
        }
      }
    },
    /**
     * 清除
     **/
    qingchu() {
      this.possform = {
        oldpossword: "",
        newpossword: "",
        newposswordtwo: "",
      };
    },
    /**
     * 根据用户id查询全部信息
     **/
    useridAll() {
      this.$http
        .request({
          url: "/api/user/userId",
          method: "GET",
          showLoading: true,
          params: {
            userId: this.userid,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.mainData = resp.data[0];
            // console.log(this.mainData);
          }
        })
        .catch((error) => {});
    },
    /**
     * 判断密码是否与近三次一致
     */
    passExist() {
      this.$http
        .request({
          url: "api/user/passExist",
          method: "GET",
          params: {
            account: this.userAccount,
            password: this.possform.newpossword,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.passIsExist = false;
          } else {
            this.passIsExist = true;
          }
        })
        .catch((error) => {});
    },
    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        lineCode: null,
        poCode: null,
        logModule: "back-SYS_SVES_PER",
        // logContent: "oldPass：" + this.possform.oldpossword + "，newPass：" + this.possform.newpossword,
        logOperator: this.mainData.userAccount || null,
        logOperatorNo: this.mainData.empNumber || null,
        // logRemarks: "center 个人中心修改密码",
        logContent: "center 个人中心修改密码",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData,
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.$message({
              message: "操作日志记录成功",
              type: "success",
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作日志记录失败",
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>